import { render } from "./B2bTableFacturasRecibidas.vue?vue&type=template&id=9ec50950&scoped=true&lang=pug"
import script from "./B2bTableFacturasRecibidas.vue?vue&type=script&lang=js"
export * from "./B2bTableFacturasRecibidas.vue?vue&type=script&lang=js"

import "./B2bTableFacturasRecibidas.vue?vue&type=style&index=0&id=9ec50950&lang=scss&scoped=true"
import "./B2bTableFacturasRecibidas.vue?vue&type=style&index=1&id=9ec50950&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ec50950"]])

export default __exports__